import { DEFAULTS } from "./consts.js";
import { IMAGE_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginImage = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: IMAGE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginImage
};
//# sourceMappingURL=viewer.js.map
